import VSLRow from "./VSLRow";
import LangUtils from '@/utils/LangUtils'

export default class VSLFormField extends VSLRow {

    constructor(id, field, locale) {
        super(id, field.type);

        this.label = LangUtils.valueForLanguage(field.label, locale);
        this.value = field.value || null;
        this.placeHolder = LangUtils.valueForLanguage(field.placeHolder, locale);
    }
}
